import { render, staticRenderFns } from "./pantalla3.vue?vue&type=template&id=8503320a&scoped=true&"
var script = {}
import style0 from "./pantalla3.vue?vue&type=style&index=0&id=8503320a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8503320a",
  null
  
)

export default component.exports